import React from 'react';
import BaseProps from "../../../types/BaseProps";
import Icon from "../../../common/Icon";
import {IconProp} from "@fortawesome/fontawesome-svg-core";
import classNames from "classnames";

import './IconButton.scss';

type IconButtonProps = BaseProps & {
  icon: IconProp,
  title?: string,
  onClick?: () => void,
  disabled?: boolean
};

/**
 * Renders action buttons for each schema in the table.
 */
class IconButton extends React.Component<IconButtonProps> {

  constructor(props: IconButtonProps) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    this.props.onClick && this.props.onClick();
  }

  render() {
    const classes = classNames('IconButton', this.props.className);
    return (
      <button type="button" onClick={this.onClick} className={classes}
              disabled={this.props.disabled}>
        <Icon icon={this.props.icon} title={this.props.title || ''} disabled={this.props.disabled}/>
      </button>
    );
  }
}

export default IconButton;
